import tinycolor from 'tinycolor2';
import { generateTheme } from '@cld/theme-helper';
import { getTextColorByBackgroundColor } from 'utils/colorUtils';

// export for testing only
export const getAltColor = (color) => tinycolor(color).darken(20).toString();

const getContrastHighColor = (bgColor, lightColor, darkColor) => getTextColorByBackgroundColor(bgColor, lightColor, darkColor);

const getContrastInvertColor = (bgColor, lightColor, darkColor) => {
  const contrastHigh = getContrastHighColor(bgColor, lightColor, darkColor);

  return lightColor === contrastHigh ? darkColor : lightColor;
};

const convertPaletteToCldTheme = (uwPalette) =>
  generateTheme({
    font: {
      size: {
        xxl: '4rem',
        xl: '3rem',
        lg: '2rem',
        md: '1.667rem',
        sm: '1.333rem',
        xs: '1.167rem',
        xxs: '1rem',
        xxxs: '0.84rem',
      },
    },
    spacing: {
      xxs: '0.5rem',
      xs: '0.75rem',
      sm: '1rem',
      md: '1.25rem',
      lg: '2rem',
      xl: '2.625rem',
      xxl: '3.5rem',
    },
    color: {
      menuIcons: uwPalette.menuIcons,
      windowBorder: uwPalette.windowBorder,
      sourceBg: uwPalette.sourceBg,
    },
    palette: {
      primary: uwPalette.link,
      error: uwPalette.error,
      success: uwPalette.complete,
      warning: uwPalette.action,
      background: uwPalette.sourceBg,
      backgroundAlt: getAltColor(uwPalette.sourceBg),
      surface: uwPalette.window,
      surfaceAlt: getAltColor(uwPalette.window),
      secondary: uwPalette.windowBorder,
      secondaryAlt: getAltColor(uwPalette.windowBorder),
      contrastHigh: getContrastHighColor(uwPalette.sourceBg, uwPalette.textLight, uwPalette.textDark),
      contrastLow: uwPalette.menuIcons,
      contrastInvert: getContrastInvertColor(uwPalette.sourceBg, uwPalette.textLight, uwPalette.textDark),
    },
  });

export { convertPaletteToCldTheme };
